module.exports = __webpack_public_path__ + "static/media/logoCnTravel.99cc22fd.jpg";